import controller from './mf-popup.controller';
import template from './mf-popup.html';

export default {
	template,
	bindings:     {
		active:            '<',
		assignIsOpen:      '&',
		card:              '<?',
		collapse:          '&?',
		expand:            '&?',
		majpressed:        '<?',
		mapIndex:          '<',
		mapPath:           '<',
		matches:           '<',
		mf:                '<?',
		moveInProgress:    '<',
		multipleSelection: '<?',
		openForm:          '@?',
		options:           '<',
		order:             '<',
		position:          '&',
		query:             '<',
		select:            '&',
		selectlist:        '<?',
		showSuggestion:    '<?',
		values:            '<',
	},
	controller,
	controllerAs: '$ctrl',
};
